import React from 'react';
import PropTypes from 'prop-types';
import Alert from '@material-ui/lab/Alert';

export function DisplayError({ error }) {
	if (!error) return null;
	let message = '';
	if (typeof error === 'object') {
		for (const e in error) {
			message += `${error[e]}\n`;
		}
	} else {
		message = error;
	}
	return (
		<Alert
			severity="error"
			style={{ whiteSpace: 'pre', textAlign: 'left', marginTop: 15 }}>
			{message}
		</Alert>
	);
}

DisplayError.propTypes = {
	error: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.arrayOf(PropTypes.object),
	]),
};
